import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Container } from "components";
import Footer from "components/footer";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useAuth } from "hooks";
import { useSelector, useDispatch } from "react-redux";
import api from "services/api";
import moment from "moment";
import BillingDetails from "./billingDetails";
import { addCountries } from "../../../redux/slices/profile_slice";
import { toast } from "react-toastify";
const MINIMUM_YEAR = 1920;

const ApplicationDetails = () => {
  const [activeMembership, setActiveMembership] = useState({});

  console.log("activeMembership:", activeMembership);

  const [imageIndex, setImageIndex] = useState(null);
  // const [relations, setRelations] = useState([]);
  const [promocode, setPromocode] = useState("");
  const [promocodeData, setPromocodeData] = useState(null);
  const [isCheckingPromocode, setIsCheckingPromocode] = useState(false);
  const [promocodeError, setPromocodeError] = useState("");

  const dispatch = useDispatch();
  const { countries, profileDataRedux } = useSelector(
    (state) => state?.profile
  );

  const { user } = useAuth();
  const params = useParams();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  /* const membershipData = {
    membership_id: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    phone_no: "",
    email: "",
    // img: "",
    // imgpath: "",
    dob: "",
    sex: "",
    relation: "",
    country_id: "", // Initialize country as null or any default value
    nationality: "",
  }; */

  const billingData = {
    billing_name: "",
    billing_email: "",
    billing_phone: "",
    billing_address: "",
    billing_state_name: "",
    billing_country_id: "95", // Set India as default (India has ID 95)
    billing_gstin: "",
    billing_pan: "",
  };

  const [initialValues, setInitialValues] = useState([]);

  const validationSchema = Yup.object({
    /* members: Yup.array().of(
      Yup.object({
        first_name: Yup.string()
          .required("Required")
          .min(3, "First name must be at least 3 characters")
          .matches(/^[A-Za-z]+$/, "Only Alphabets"),
        middle_name: Yup.string()
          // .required("Required")
          // .min(3, "Middle name must be at least 3 characters")
          .matches(/^[A-Za-z]+$/, "Only Alphabets"),
        last_name: Yup.string()
          // .required("Required")
          // .min(3, "Last name must be at least 3 characters")
          .matches(/^[A-Za-z]+$/, "Only Alphabets"),
        phone_no: Yup.string()
          .required("Required")
          .length(10, "Phone number must be exactly 10 digits")
          .matches(/[0-9]+$/, "only numeric"),
        email: Yup.string()
          .email("Invalid email")
          .required("Required")
          .matches(
            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
            "Invalid email format"
          ),
        // img: Yup.string(),
        dob: Yup.string().required("Required"),
        // .test('is-valid-date', 'Invalid date format', function (value) {
        //   const dob = new Date(value);
        //   // Check if the date is valid
        //   if (isNaN(dob.getTime())) {
        //     return false; // Invalid date entered
        //   }
        //   return true;
        // })
        // .test('is-valid-year', `Date must be after ${MINIMUM_YEAR}`, function (value) {
        //   const dob = new Date(value);
        //   // Reject if the year is before MINIMUM_YEAR
        //   return dob.getFullYear() >= MINIMUM_YEAR;
        // })
        sex: Yup.string().required("Required"),
        relation: Yup.string().required("Required"),
        // nationality: Yup.string().required("Required"),
        nationality: Yup.number(), // Remove required validation since it's disabled
      })
    ), */
    // Billing details validation
    billing_name: Yup.string().required("Billing name is required"),
    billing_email: Yup.string()
      .email("Invalid email format")
      .required("Billing email is required"),
    billing_phone: Yup.string()
      .required("Billing phone number is required")
      .length(10, "Phone number must be exactly 10 digits")
      .matches(/^[0-9]+$/, "Only numeric values allowed"),
    billing_address: Yup.string()
      .required("Billing address is required")
      .min(10, "Address must be at least 10 characters"),
    billing_state_name: Yup.string().required("State is required"),
    billing_country_id: Yup.string(), // Remove required validation since it's disabled
    billing_gstin: Yup.string()
      .matches(/^[0-9A-Z]{15}$/, "GSTIN must be 15 characters (alphanumeric)")
      .nullable(),
    billing_pan: Yup.string()
      .matches(
        /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        "PAN must be in format: ABCDE1234F"
      )
      .nullable(),
    agree: Yup.boolean().required("Please agree to the terms and conditions"),
    // .oneOf([true], "You must accept the terms and conditions")
    // .required("You must accept the terms and conditions"),
  });

  useEffect(() => {
    if (profileDataRedux) {
      setInitialValues([]);
    }
  }, [profileDataRedux]);

  /* const fetchRelaction = async () => {
    try {
      const response = await api.get(`${RELATIONS}`);
      setRelations(response.data.data.relations);
    } catch (error) {}
  }; */

  useEffect(() => {
    fetchMembership();
    // fetchRelaction();
    if (countries?.length === 0) {
      api.get("/countries").then((res) => {
        let countriesList = res?.data?.data?.countries || [];
        if (countriesList?.length > 0) {
          dispatch(addCountries(countriesList));
        }
      });
    }
  }, [params?.id]);

  const fetchMembership = () => {
    api.get(`/membership-plans/${params?.id}`).then((res) => {
      if (res?.data?.data?.membershipPlans) {
        setActiveMembership(res?.data?.data?.membershipPlans);
      }
    });
  };

  const handleCheckPromocode = async () => {
    if (!promocode || promocode.trim() === "") {
      setPromocodeError("Please enter a promocode");
      return;
    }

    setIsCheckingPromocode(true);
    setPromocodeError("");

    try {
      const response = await api.post("/apply-promocode", {
        promocode: promocode,
        membership_plan_id: activeMembership?.id,
      });

      if (response?.data?.success) {
        setPromocodeData(response?.data?.data);
        toast.success(
          response?.data?.message || "Promocode applied successfully"
        );
      }
    } catch (error) {
      setPromocodeError(
        error?.response?.data?.message || "Invalid promocode"
      );
      setPromocodeData(null);
      toast.error(error?.response?.data?.message || "Invalid promocode");
    } finally {
      setIsCheckingPromocode(false);
    }
  };

  const handleSubmit = (values) => {
    /* let payload = [];
    values.members.forEach((mem) => {
      let obj = { ...mem };
      // delete obj.imgpath;
      obj.dob = moment(obj.dob, "DD-MM-YYYY").format("DD-MM-YYYY");
      payload.push(obj);
    }); */
    const formData = new FormData();
    /* payload.forEach((res, i) => {
      Object.entries(res).forEach((mem) => {
        formData.append(`${mem[0]}[${i}]`, mem[1]);
      });
    }); */

    // Add billing details to form data
    Object.entries(values).forEach(([key, value]) => {
      if (key.startsWith("billing_") && value) {
        formData.append(key, value);
      }
    });
    formData.append("billing_country_id", "95");

    // Add promocode if applied
    if (promocodeData && promocode) {
      formData.append("promocode", promocode);
    }

    formData.append("membership_id", activeMembership.id);
    formData.append("user_id", user?.user_id);
    api
      .post("/membership-application", formData)
      .then((res) => {
        console.log("membership-application:", res);
        const paymentData = res.data.paymentData;

        // Check if payment is required (not 100% discount)
        if (paymentData.payment_required === false || !paymentData.action) {
          // 100% discount - no payment required
          toast.success(
            res?.data?.message ||
            "Membership application completed successfully!"
          );
          // Redirect to success page
          navigate("/payment/success");
        } else {
          // Payment required - redirect to payment gateway
          const form = document.createElement("form");
          form.method = "POST";
          form.action = paymentData.action;

          Object.keys(paymentData).forEach((key) => {
            if (key !== "action") {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = key;
              input.value = paymentData[key];
              form.appendChild(input);
            }
          });

          document.body.appendChild(form);
          form.submit();
          // payment gateway function end
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  /* const addMemBeship = (values, setValues) => {
    const updateValues = {
      members: [...values.members, { ...membershipData, relation: "" }], //this is no auto fill relation second add member
    };
    setValues(updateValues);
  };
  const removeMemForm = (index, values, setValue) => {
    const updatedMembers = values?.members?.filter((_, i) => i !== index);
    setValue({ ...values, members: updatedMembers });
  }; */
  return (
    <Container>
      <div class="content-wrapper">
        <div class="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb" className="ms-4">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="/plans">Plans</Link>
              </li>
              <li class="breadcrumb-item">
                <Link to={`/selectedPlan/${params?.id}`}>Plan details</Link>
              </li>
              <li class="breadcrumb-item active">Plan form</li>
            </ol>
          </nav>
        </div>
        <Formik
          initialValues={{
            // members: initialValues,
            ...billingData,
          }}
          validationSchema={validationSchema}
          enableReinitialize
          validateOnMount={false}
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {({
            values,
            setFieldValue,
            errors,
            setValues,
            setFieldError,
            validateForm,
            touched,
            submitForm,
            setTouched,
          }) => (
            <>
              <Form>
                {/* {values?.members?.map((mem, i) => {
                  return (
                    <ApplicationForm
                      setFieldValue={setFieldValue}
                      relations={relations}
                      countries={countries}
                      values={values}
                      addMemBeship={addMemBeship}
                      setValues={setValues}
                      mem={mem}
                      isLast={
                        values?.members?.length - 1 === i &&
                        activeMembership?.no_of_users !==
                          values?.members?.length
                      }
                      removeMemForm={() => removeMemForm(i, values, setValues)}
                      formIndex={i}
                      activeMembership={activeMembership}
                      errors={errors}
                      touched={touched}
                      validateForm={validateForm}
                      isDynamic={true}
                    />
                  );
                })} */}

                {/* Billing Details Section */}
                <BillingDetails
                  setFieldValue={setFieldValue}
                  values={values}
                  countries={countries}
                  setFieldError={setFieldError}
                  errors={errors}
                  touched={touched}
                />

                {/* Promocode Section */}
                <div class="card mb-4 mx-4">
                  <h5 class="card-header">Apply Promocode</h5>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Enter promocode"
                            value={promocode}
                            onChange={(e) => {
                              setPromocode(e.target.value.toUpperCase());
                              setPromocodeError("");
                            }}
                            disabled={promocodeData !== null}
                          />
                          <button
                            type="button"
                            class="btn btn-primary"
                            onClick={handleCheckPromocode}
                            disabled={isCheckingPromocode || promocodeData !== null}
                          >
                            {isCheckingPromocode ? "Checking..." : "Check"}
                          </button>
                          {promocodeData && (
                            <button
                              type="button"
                              class="btn btn-danger ms-2"
                              onClick={() => {
                                setPromocode("");
                                setPromocodeData(null);
                                setPromocodeError("");
                              }}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                        {promocodeError && (
                          <div class="text-danger mt-2">{promocodeError}</div>
                        )}
                        {promocodeData && (
                          <div class="alert alert-success mt-3">
                            <strong>Promocode Applied!</strong>
                            <div>
                              Code: {promocodeData?.promocode?.code} -{" "}
                              {promocodeData?.promocode?.discount_percentage}% OFF
                            </div>
                            <div class="text-success fw-bold">
                              You save: ₹{promocodeData?.pricing?.you_save}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Membership Plan Details and GST Information */}
                <div class="card mb-4 mx-4">
                  <h5 class="card-header">Plan Details & GST Information</h5>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <h6 class="mb-3">Selected Plan Details:</h6>
                        <div class="mb-2">
                          <strong>Plan Title:</strong>{" "}
                          {activeMembership?.title || "N/A"}
                        </div>
                        <div class="mb-2">
                          <strong>Description:</strong>{" "}
                          {activeMembership?.short_text || "N/A"}
                        </div>
                        <div class="mb-2">
                          <strong>Duration:</strong>{" "}
                          {activeMembership?.duration}{" "}
                          {activeMembership?.duration_type}
                        </div>
                        <div class="mb-2">
                          <strong>Package Price:</strong> ₹
                          {activeMembership?.package_price || "N/A"}
                        </div>
                        {promocodeData && (
                          <>
                            <div class="mb-2 text-success">
                              <strong>Discount ({promocodeData?.promocode?.discount_percentage}%):</strong> -₹
                              {promocodeData?.pricing?.discount_amount}
                            </div>
                            <div class="mb-2 text-success">
                              <strong>Discounted Price:</strong> ₹
                              {promocodeData?.pricing?.final_price}
                            </div>
                          </>
                        )}
                        <div class="mb-2">
                          <strong>Max Users:</strong>{" "}
                          {activeMembership?.no_of_users || "N/A"}
                        </div>
                      </div>
                      <div class="col-md-6">
                        <h6 class="mb-3">GST Information:</h6>
                        <div class="mb-2">
                          <strong>GSTIN:</strong> 29AACCZ3275B1ZA
                        </div>

                        <div class="mb-2">
                          <strong>Sub Total:</strong> ₹
                          {promocodeData
                            ? parseFloat(promocodeData?.pricing?.final_price || 0).toFixed(2)
                            : (activeMembership?.package_price || 0)}
                        </div>

                        {values?.billing_state_name === "Karnataka" ? (
                          <>
                            <div class="mb-2">
                              <strong>SGST @ 9% :</strong> ₹
                              {parseFloat(
                                (
                                  (promocodeData
                                    ? parseFloat(promocodeData?.pricing?.final_price || 0)
                                    : (activeMembership?.package_price || 0)) * 0.09
                                ).toFixed(2)
                              )}
                            </div>
                            <div class="mb-2">
                              <strong>CGST @ 9% :</strong> ₹
                              {parseFloat(
                                (
                                  (promocodeData
                                    ? parseFloat(promocodeData?.pricing?.final_price || 0)
                                    : (activeMembership?.package_price || 0)) * 0.09
                                ).toFixed(2)
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <div class="mb-2">
                              <strong>IGST @ 18% :</strong> ₹
                              {parseFloat(
                                (
                                  (promocodeData
                                    ? parseFloat(promocodeData?.pricing?.final_price || 0)
                                    : (activeMembership?.package_price || 0)) * 0.18
                                ).toFixed(2)
                              )}
                            </div>
                          </>
                        )}

                        <div class="mb-2">
                          <strong>Total Amount Payable :</strong> ₹
                          {(() => {
                            const basePrice = parseFloat(
                              promocodeData
                                ? (promocodeData?.pricing?.final_price || 0)
                                : (activeMembership?.package_price || 0)
                            );
                            const gstAmount = basePrice * 0.18;
                            const totalAmount = basePrice + gstAmount;
                            return totalAmount.toFixed(2);
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card mb-4  mx-4">
                  <h5 class="card-header">Consent</h5>

                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12 mb-1">
                        <div class="mb-3">
                          <p>
                            <Field
                              class="form-check-input me-2"
                              type="checkbox"
                              name="agree"
                            />{" "}
                            I agree to &nbsp;
                            <Link to="/termsConditions" target="blank">
                              Terms and Conditions
                            </Link>{" "}
                            and{" "}
                            <Link to="/privacyPolicy" target="blank">
                              Privacy Policy
                            </Link>{" "}
                            <br />
                          </p>
                          <div className="invalid-form">{errors.agree}</div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2">
                      <button
                        type="submit"
                        class="btn btn-primary me-2"
                        onClick={() => {
                          console.log("Form submitted", errors);
                          let isBilling = Object.keys(errors).filter((item) =>
                            item.includes("billing")
                          );
                          let isMember = Object.keys(errors).filter((item) =>
                            item.includes("members")
                          );
                          if (isBilling.length) {
                            toast.error(
                              "Please fill the required billing details."
                            );
                          }
                          /* if (isMember.length) {
                            toast.error(
                              "Please fill the required membership  details."
                            );
                          } */
                        }}
                      >
                        Buy
                      </button>
                      <button type="reset" class="btn btn-label-secondary">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </>
          )}
        </Formik>
        <Footer />
        <div class="content-backdrop fade"></div>
      </div>
    </Container>
  );
};

export default ApplicationDetails;
